import {
  Button,
} from 'antd';
import React, { useState, useEffect } from 'react';
import AddSuggestedStationModal from '../../modals/addSuggestedStationModal/AddSuggestedStationModal';
import SuggestedStationsTable from '../../tables/suggestedStationsTable/SuggestedStationsTable';
import { getSuggestedStations } from '../../../../services/admin/stationServices';
import useTranslation from '../../../hooks/translation/useTranslation';

function SuggestedStations() {
  const { trans } = useTranslation();
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);

  const fetchData = async () => {
    const response = await getSuggestedStations();
    setData(response);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="flex flex-col gap-3">
      <Button
        onClick={() => setShow(true)}
      >
        {trans('add')}
      </Button>
      <SuggestedStationsTable data={data} refetchData={fetchData} />
      <AddSuggestedStationModal setShow={setShow} show={show} refetchData={fetchData} />
    </div>
  );
}

export default SuggestedStations;
